import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=3ae26b94"
import script from "./ShareLinks.vue?vue&type=script&lang=js"
export * from "./ShareLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports